import logo from './logo.svg';
import Tours from './Tours';

function App() {
  return (
    <div className="App">
      <a href='https://www.mrhussain.in/portfolio/' className='back-btn'>Back to Portfolio</a>
      <Tours />
    </div>
  );
}

export default App;
